'use client'
import Image from 'next/image'
import Link from 'next/link'
import { ReactNode } from 'react'

import { AnimatedDemo } from "@/components/animated-demo"

export default function Layout({ children }: { children: ReactNode }) {

  return (


    <div className="min-h-screen flex">


    <style jsx global>{`
            :root {
              --background: 0 0% 100%;
              --foreground: 222.2 84% 4.9%;
              --card: 0 0% 100%;
              --card-foreground: 222.2 84% 4.9%;
              --popover: 0 0% 100%;
              --popover-foreground: 222.2 84% 4.9%;
              --primary: 222.2 47.4% 11.2%;
              --primary-foreground: 210 40% 98%;
              --secondary: 210 40% 96%;
              --secondary-foreground: 222.2 84% 4.9%;
              --muted: 210 40% 96%;
              --muted-foreground: 215.4 16.3% 46.9%;
              --accent: 210 40% 96%;
              --accent-foreground: 222.2 84% 4.9%;
              --destructive: 0 84.2% 60.2%;
              --destructive-foreground: 210 40% 98%;
              --border: 214.3 31.8% 91.4%;
              --input: 214.3 31.8% 91.4%;
              --ring: 222.2 84% 4.9%;
              --radius: 0.5rem;
            }
            
            .light {
              color-scheme: light;
            }
            
            .light * {
              color-scheme: light;
            }
          `}</style>
      
      {/* Left Column - Forms */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-md space-y-6">
          <div className="flex justify-center mb-8">
            <Image
              src="/fastfold_white.svg"
              alt="logo"
              width={200}
              height={67}
              priority
              style={{ width: '200px', height: '67px' }}
            />
          </div>

          {children}
          
          <div className="text-center text-sm text-gray-600">
            Need help? Send us an email at{' '}
            <Link
              href="mailto:hello@fastfold.ai"
              className="text-sm text-blue-600 hover:text-blue-700"
            >
              hello@fastfold.ai
            </Link>
          </div>
        </div>
      </div>

      {/* Right Column - Gradient Background with PromptInputBox */}
      <div 
        className="hidden lg:block w-1/2 rounded-2xl m-4 relative p-8"
        style={{
          background: 'radial-gradient(125% 125% at 100% 101%, rgba(245,87,2,1) 10.5%, rgba(245,120,2,1) 16%, rgba(245,140,2,1) 17.5%, rgba(245,170,100,1) 25%, rgba(238,174,202,1) 40%, rgba(202,179,214,1) 65%, rgba(148,201,233,1) 100%)'
        }}
      >
        <div className="absolute inset-0 flex justify-center items-center">
          <AnimatedDemo />
        </div>
      </div>
    </div>
  )
}
